module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', [(!_vm.IsModal) ? _c('h2', {
    staticClass: "page-header"
  }, [_c('span', {
    attrs: {
      "id": "page-header"
    }
  }, [_vm._v(_vm._s(_vm.pageheader))]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h3', {
    staticClass: "col-lg-12"
  }, [_vm._v("Persönliche Informationen  "), _c('router-link', {
    staticClass: "btn btn-primary create-new pull-right",
    attrs: {
      "to": "/deceaseds/new"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal",
    attrs: {
      "id": "customer-information"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('custom-input', {
    attrs: {
      "inline": ""
    }
  }, [_c('label', {
    staticClass: "col-md-12 control-label",
    attrs: {
      "for": "firstname"
    }
  }, [_vm._v("Vorname "), _c('span', {
    staticStyle: {
      "color": "#f00",
      "font-weight": "800"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.model.firstname),
      expression: "model.model.firstname"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "firstname",
      "id": "firstname",
      "required": ""
    },
    domProps: {
      "value": (_vm.model.model.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.model.firstname = $event.target.value
      }
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('custom-input', {
    attrs: {
      "inline": ""
    }
  }, [_c('label', {
    staticClass: "col-sm-12 control-label",
    attrs: {
      "for": "lastname"
    }
  }, [_vm._v("Nachname "), _c('span', {
    staticStyle: {
      "color": "#f00",
      "font-weight": "800"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.model.lastname),
      expression: "model.model.lastname"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "lastname",
      "id": "lastname",
      "required": ""
    },
    domProps: {
      "value": (_vm.model.model.lastname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.model.lastname = $event.target.value
      }
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('custom-input', {
    attrs: {
      "inline": ""
    }
  }, [_c('label', {
    staticClass: "col-sm-12 control-label",
    attrs: {
      "for": "birthname"
    }
  }, [_vm._v("Geburtsname")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.model.birthname),
      expression: "model.model.birthname"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "birthname",
      "id": "birthname",
      "required": ""
    },
    domProps: {
      "value": (_vm.model.model.birthname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.model.birthname = $event.target.value
      }
    }
  })])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('custom-input', {
    attrs: {
      "inline": ""
    }
  }, [_c('label', {
    staticClass: "col-sm-12 control-label",
    attrs: {
      "for": "birthplace"
    }
  }, [_vm._v("Geburtsort")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.model.birthplace),
      expression: "model.model.birthplace"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "birthplace",
      "id": "birthplace",
      "required": ""
    },
    domProps: {
      "value": (_vm.model.model.birthplace)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.model.birthplace = $event.target.value
      }
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('custom-input', {
    attrs: {
      "inline": ""
    }
  }, [_c('label', {
    staticClass: "col-sm-12 control-label",
    attrs: {
      "for": "denomination"
    }
  }, [_vm._v("Konfession")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.model.denomination_id),
      expression: "model.model.denomination_id"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "burial_type",
      "id": "denomination"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.model.model.denomination_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("[Keine Konfession]")]), _vm._v(" "), _vm._l((_vm.$store.getters.models('denominations')), function(type) {
    return _c('option', {
      domProps: {
        "value": type.id
      }
    }, [_vm._v(_vm._s(type.name))])
  })], 2)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('custom-input', {
    attrs: {
      "inline": ""
    }
  }, [_c('label', {
    staticClass: "col-sm-12 control-label",
    attrs: {
      "for": "lastname"
    }
  }, [_vm._v("Geschlecht "), _c('span', {
    staticStyle: {
      "color": "#f00",
      "font-weight": "800"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.model.gender),
      expression: "model.model.gender"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "gender"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.model.model.gender = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("[Bitte wählen]")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("männlich")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("weiblich")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("transgender")])])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('custom-input', {
    attrs: {
      "inline": ""
    }
  }, [_c('label', {
    staticClass: "col-sm-12 control-label",
    attrs: {
      "for": "birthday"
    }
  }, [_vm._v("Geburtstag "), _c('span', {
    staticStyle: {
      "color": "#f00",
      "font-weight": "800"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('datepicker', {
    attrs: {
      "id": "birthday",
      "bootstrapStyling": "",
      "calendar-button": "",
      "calendar-button-icon": "fa fa-calendar",
      "name": "birthday",
      "required": "",
      "language": "de",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.model.model.birthday),
      callback: function($$v) {
        _vm.model.model.birthday = $$v
      },
      expression: "model.model.birthday"
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('custom-input', {
    attrs: {
      "inline": ""
    }
  }, [_c('label', {
    staticClass: "col-sm-12 control-label",
    attrs: {
      "for": "dyingday"
    }
  }, [_vm._v("Todestag "), _c('span', {
    staticStyle: {
      "color": "#f00",
      "font-weight": "800"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('datepicker', {
    attrs: {
      "id": "dyingday",
      "bootstrapStyling": "",
      "calendar-button": "",
      "calendar-button-icon": "fa fa-calendar",
      "name": "dyingday",
      "required": "",
      "language": "de",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.model.model.dyingday),
      callback: function($$v) {
        _vm.model.model.dyingday = $$v
      },
      expression: "model.model.dyingday"
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('custom-input', {
    attrs: {
      "inline": ""
    }
  }, [_c('label', {
    staticClass: "col-sm-12 control-label",
    attrs: {
      "for": "burial"
    }
  }, [_vm._v("Beisetzung")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('datepicker', {
    attrs: {
      "id": "burial",
      "bootstrapStyling": "",
      "clear-button": "",
      "clear-button-icon": "fa fa-trash",
      "calendar-button": "",
      "calendar-button-icon": "fa fa-calendar",
      "name": "burial",
      "required": "",
      "language": "de",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.model.model.burial),
      callback: function($$v) {
        _vm.model.model.burial = $$v
      },
      expression: "model.model.burial"
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('custom-input', {
    attrs: {
      "inline": ""
    }
  }, [_c('label', {
    staticClass: "col-sm-12 control-label",
    attrs: {
      "for": "mourning"
    }
  }, [_vm._v("Trauerfeier")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('datepicker', {
    attrs: {
      "id": "mourning",
      "bootstrapStyling": "",
      "clear-button": "",
      "clear-button-icon": "fa fa-trash",
      "calendar-button": "",
      "calendar-button-icon": "fa fa-calendar",
      "name": "mourning",
      "required": "",
      "language": "de",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.model.model.mourning),
      callback: function($$v) {
        _vm.model.model.mourning = $$v
      },
      expression: "model.model.mourning"
    }
  })], 1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('custom-input', {
    attrs: {
      "inline": ""
    }
  }, [_c('label', {
    staticClass: "col-sm-12 control-label",
    attrs: {
      "for": "urn_number"
    }
  }, [_vm._v("Ident.-Nummer")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.model.urn_number),
      expression: "model.model.urn_number"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "urn_number",
      "name": "urn_number",
      "required": ""
    },
    domProps: {
      "value": (_vm.model.model.urn_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.model.urn_number = $event.target.value
      }
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('custom-input', {
    attrs: {
      "inline": ""
    }
  }, [_c('label', {
    staticClass: "col-sm-12 control-label",
    attrs: {
      "for": "crematory"
    }
  }, [_vm._v("Krematorium")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.model.crematory_name),
      expression: "model.model.crematory_name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "crematory",
      "name": "crematory",
      "required": "required",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.model.model.crematory_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.model.crematory_name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon addon-primary",
    on: {
      "click": function($event) {
        _vm.selectCrematory()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })]), _vm._v(" "), (_vm.model.model.crematory_id > 0) ? _c('router-link', {
    staticClass: "input-group-addon addon-success",
    attrs: {
      "to": '/crematories/' + _vm.model.model.crematory_id
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-right"
  })]) : _vm._e()], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('custom-input', {
    attrs: {
      "inline": ""
    }
  }, [_c('label', {
    staticClass: "col-sm-12 control-label",
    attrs: {
      "for": "burial_type"
    }
  }, [_vm._v("Bestattungsart")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.model.burial_type_id),
      expression: "model.model.burial_type_id"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "burial_type",
      "id": "burial_type",
      "placeholder": _vm.model.model.burial_type
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.model.model.burial_type_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.$store.getters.models('burial_types')), function(type) {
    return _c('option', {
      domProps: {
        "value": type.id
      }
    }, [_vm._v(_vm._s(type.name))])
  }))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('custom-input', {
    attrs: {
      "inline": ""
    }
  }, [_c('label', {
    staticClass: "col-sm-12 control-label",
    attrs: {
      "for": "undertaker"
    }
  }, [_vm._v("Bestatter")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.model.undertaker_name),
      expression: "model.model.undertaker_name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "undertaker",
      "name": "undertaker",
      "required": "required",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.model.model.undertaker_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.model.undertaker_name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon addon-primary",
    on: {
      "click": function($event) {
        _vm.selectUndertaker()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })]), _vm._v(" "), (_vm.model.model.undertaker_id > 0) ? _c('router-link', {
    staticClass: "input-group-addon addon-success",
    attrs: {
      "to": '/undertakers/' + _vm.model.model.undertaker_id
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-right"
  })]) : _vm._e()], 1)])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [(!_vm.IsModal) ? _c('div', {
    staticClass: "col-lg-12 text-center"
  }, [_vm._m(1), _vm._v(" "), (_vm.validModel) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.saveDeceased()
      }
    }
  }, [_vm._v("Speichern")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.IsModal) ? _c('div', {
    staticClass: "col-lg-12 text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !_vm.validModel
    },
    on: {
      "click": function($event) {
        _vm.emitDeceased()
      }
    }
  }, [_vm._v("Speichern")])]) : _vm._e()])])]), _vm._v(" "), (!_vm.IsModal) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.model.id > 0),
      expression: "model.model.id > 0"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "tab-content col-lg-12"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "addresses"
    }
  }, [_c('custom-table', {
    attrs: {
      "cols": _vm.addresses.cols,
      "src-model": _vm.model.addresses,
      "add": "",
      "delete": "",
      "edit": "",
      "nosort": ""
    },
    on: {
      "add": _vm.addAddress,
      "edit": _vm.editAddress,
      "delete": _vm.deleteAddress
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "customers"
    }
  }, [_c('custom-table', {
    attrs: {
      "cols": _vm.customers.cols,
      "src-model": _vm.model.customers,
      "add": "",
      "delete": "",
      "nosort": "",
      "select": "/customers/{:customer_id}",
      "default-sort": _vm.defSort
    },
    on: {
      "add": _vm.addCustomer,
      "delete": _vm.deleteCustomer
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "graves"
    }
  }, [_c('custom-table', {
    attrs: {
      "cols": _vm.graveCols,
      "src-model": _vm.model.graves,
      "add": "",
      "edit": "",
      "delete": "",
      "nosort": "",
      "select": "/graves/{:grave_id}"
    },
    on: {
      "add": _vm.addGrave,
      "edit": _vm.editGrave,
      "delete": _vm.deleteGrave
    }
  })], 1)])])])]) : _vm._e()]), _vm._v(" "), _c('custom-message', {
    ref: "messenger"
  })], 1), _vm._v(" "), _c('custom-modal', {
    ref: "addressModal",
    attrs: {
      "title": "Adresse hinzufügen",
      "ok-text": "Speichern",
      "cancel-text": "Abbrechen",
      "ok-style": "btn btn-primary",
      "cancel-style": "btn btn-default"
    }
  }, [_c('address-content', {
    ref: "newAddress"
  })], 1), _vm._v(" "), (_vm.visibleModal === 'deleteaddresses') ? _c('custom-modal-old', {
    attrs: {
      "title": "Adresse löschen",
      "ok-text": "Löschen",
      "cancel-text": "Abbrechen",
      "cancel-style": "btn btn-primary",
      "ok-style": "btn btn-danger"
    },
    on: {
      "ok": function($event) {
        _vm.confirmDeleteRelation('addresses')
      },
      "cancel": function($event) {
        _vm.visibleModal = ''
      }
    }
  }, [_c('strong', [_vm._v("Sind Sie sicher, dass Sie diese Adresse entfernen möchten?")])]) : _vm._e(), _vm._v(" "), (_vm.visibleModal === 'selectundertakers') ? _c('custom-modal-old', {
    attrs: {
      "title": "Bestatter auswählen"
    },
    on: {
      "cancel": function($event) {
        _vm.visibleModal = ''
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('custom-table', {
    attrs: {
      "row-add": "",
      "src-model": _vm.$store.getters.models('undertakers'),
      "cols": [{
        name: 'Name',
        json: 'name',
        'type': 'text'
      }],
      "store": "undertakers",
      "search": "",
      "default-sort": _vm.defSort
    },
    on: {
      "rowAdd": _vm.pickUndertaker
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.visibleModal === 'selectcrematories') ? _c('custom-modal-old', {
    attrs: {
      "title": "Krematorium auswählen"
    },
    on: {
      "cancel": function($event) {
        _vm.visibleModal = ''
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('custom-table', {
    attrs: {
      "row-add": "",
      "src-model": _vm.$store.getters.models('crematories'),
      "cols": [{
        name: 'Name',
        json: 'name',
        'type': 'text'
      }],
      "store": "crematories",
      "search": "",
      "default-sort": _vm.defSort
    },
    on: {
      "rowAdd": _vm.pickCrematory
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('custom-modal', {
    ref: "graveModal",
    attrs: {
      "title": "Grabstätte hinzufügen"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-10"
  }, [_c('custom-input', {
    attrs: {
      "title": "Grab"
    }
  }, [_c('custom-table', {
    attrs: {
      "row-add": "",
      "src-model": _vm.$store.getters.models('graves'),
      "cols": _vm.graveCols,
      "store": "graves",
      "search": "",
      "default-sort": _vm.graveSort
    },
    on: {
      "rowAdd": _vm.saveGrave
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('custom-input', {
    attrs: {
      "title": "Von"
    }
  }, [_c('datepicker', {
    attrs: {
      "bootstrapStyling": "",
      "calendar-button": "",
      "calendar-button-icon": "fa fa-calendar",
      "name": "from",
      "required": "",
      "language": "de",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.graves.model.from),
      callback: function($$v) {
        _vm.graves.model.from = $$v
      },
      expression: "graves.model.from"
    }
  })], 1), _vm._v(" "), _c('custom-input', {
    attrs: {
      "title": "Bis"
    }
  }, [_c('datepicker', {
    attrs: {
      "bootstrapStyling": "",
      "calendar-button": "",
      "calendar-button-icon": "fa fa-calendar",
      "name": "until",
      "required": "",
      "language": "de",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.graves.model.until),
      callback: function($$v) {
        _vm.graves.model.until = $$v
      },
      expression: "graves.model.until"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('custom-modal', {
    ref: "graveEditModal",
    attrs: {
      "title": "Grabstätte bearbeiten",
      "ok-text": "Aktualisieren",
      "cancel-text": "Abbrechen",
      "cancel-style": "btn btn-default"
    }
  }, [_c('custom-input', {
    attrs: {
      "title": "Von"
    }
  }, [_c('datepicker', {
    attrs: {
      "bootstrapStyling": "",
      "calendar-button": "",
      "calendar-button-icon": "fa fa-calendar",
      "name": "from",
      "required": "",
      "language": "de",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.graves.model.from),
      callback: function($$v) {
        _vm.graves.model.from = $$v
      },
      expression: "graves.model.from"
    }
  })], 1), _vm._v(" "), _c('custom-input', {
    attrs: {
      "title": "Bis"
    }
  }, [_c('datepicker', {
    attrs: {
      "bootstrapStyling": "",
      "calendar-button": "",
      "calendar-button-icon": "fa fa-calendar",
      "name": "until",
      "required": "",
      "language": "de",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.graves.model.until),
      callback: function($$v) {
        _vm.graves.model.until = $$v
      },
      expression: "graves.model.until"
    }
  })], 1)], 1), _vm._v(" "), (_vm.visibleModal === 'deletegraves') ? _c('custom-modal-old', {
    attrs: {
      "title": "Grab entfernen",
      "ok-text": "Löschen",
      "cancel-text": "Abbrechen",
      "ok-style": "btn btn-danger"
    },
    on: {
      "ok": function($event) {
        _vm.confirmDeleteRelation('graves')
      },
      "cancel": function($event) {
        _vm.visibleModal = ''
      }
    }
  }, [_c('strong', [_vm._v("Sind Sie sicher, dass Sie das Grab entfernen möchten?")])]) : _vm._e(), _vm._v(" "), _c('custom-modal', {
    ref: "customerAddModal",
    attrs: {
      "title": "Ansprechpartner hinzufügen"
    }
  }, [_c('tabs', [_c('tab', {
    attrs: {
      "header": "Hinzufügen"
    }
  }, [_c('custom-table', {
    attrs: {
      "row-add": "",
      "src-model": _vm.$store.getters.models('customers'),
      "search": "",
      "cols": _vm.customerCols,
      "default-sort": _vm.defSort
    },
    on: {
      "rowAdd": _vm.storeCustomer
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.visibleModal === 'deletecustomers') ? _c('custom-modal-old', {
    attrs: {
      "title": "Nutzungsberechtigten entfernen",
      "ok-text": "Löschen",
      "cancel-text": "Abbrechen",
      "ok-style": "btn btn-danger"
    },
    on: {
      "ok": function($event) {
        _vm.confirmDeleteRelation('customers')
      },
      "cancel": function($event) {
        _vm.visibleModal = ''
      }
    }
  }, [_c('strong', [_vm._v("Sind Sie sicher, dass Sie diesen Nutzungsberechtigten entfernen möchten?")])]) : _vm._e(), _vm._v(" "), (_vm.visibleModal === 'errSavingModel') ? _c('custom-modal-old', {
    attrs: {
      "ok-text": "OK"
    },
    on: {
      "ok": function($event) {
        _vm.visibleModal = ''
      },
      "cancel": function($event) {
        _vm.visibleModal = ''
      }
    }
  }, [_vm._v("\r\n\t\t\tFehler beim Speichern des Kunden.\r\n\t\t")]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "hidden-md hidden-lg",
    attrs: {
      "href": "/deceaseds/"
    }
  }, [_c('button', {
    staticClass: "btn btn-success"
  }, [_vm._v("Zur Liste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "hidden-sm hidden-xs",
    attrs: {
      "href": "/deceaseds/"
    }
  }, [_c('button', {
    staticClass: "btn btn-success"
  }, [_vm._v("Zur Liste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs responsive-tabs"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#addresses"
    }
  }, [_vm._v("Letzte bekannte Adressen")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#customers"
    }
  }, [_vm._v("Ansprechpartner")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#graves"
    }
  }, [_vm._v("Grabstätten")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-369dd86d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/DeceasedEdit.vue
// module id = 442
// module chunks = 0